import React from "react";
import Button from "@material-ui/core/Button";
import TextField from "@material-ui/core/TextField";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import { languages } from "../../constants/languages";
import Typography from "@material-ui/core/Typography";
import InfoIcon from "@material-ui/icons/Info";
import SignupEmailTexts from "../../constants/SignupEmailTexts";

export default class DescriptionDialog extends React.Component {
  render() {
    return (
      <Dialog
        open={this.props.open}
        onClose={this.props.toggleDialog}
        aria-labelledby="form-dialog-title"
      >
        <DialogTitle id="form-dialog-title">{this.props.title}</DialogTitle>
        <form>
          <DialogContent style={{ width: 400, maxWidth: "97%", paddingTop: 0 }}>
            <DialogContentText />
            <TextField
              fullWidth
              label={languages.signupPage.confirmationEmailSubject}
              name="emailSubject"
              value={
                this.props.emailTexts[
                  "emailSubject" +
                    (this.props.trEmailTexts ? this.props.trEmailTexts : "")
                ] === undefined
                  ? SignupEmailTexts.confirmationEmailSubjectText[
                      (this.props.tournament.lang || [])[
                        this.props.trEmailTexts
                          ? (this.props.tournament.lang || []).indexOf(
                              this.props.trEmailTexts
                            )
                          : 0
                      ]
                        ? (this.props.tournament.lang || [])[
                            this.props.trEmailTexts
                              ? (this.props.tournament.lang || []).indexOf(
                                  this.props.trEmailTexts
                                )
                              : 0
                          ]
                        : languages.getLanguage()
                    ]
                  : this.props.emailTexts[
                      "emailSubject" +
                        (this.props.trEmailTexts ? this.props.trEmailTexts : "")
                    ]
              }
              type="text"
              style={{ marginBottom: 20 }}
              onChange={this.props.handleChange}
            />

            <TextField
              fullWidth
              id="textarea"
              label={languages.signupPage.confirmationEmailStart}
              name="emailStart"
              multiline
              value={
                this.props.emailTexts[
                  "emailStart" +
                    (this.props.trEmailTexts ? this.props.trEmailTexts : "")
                ] === undefined
                  ? SignupEmailTexts.confirmationEmailStartText[
                      (this.props.tournament.lang || [])[
                        this.props.trEmailTexts
                          ? (this.props.tournament.lang || []).indexOf(
                              this.props.trEmailTexts
                            )
                          : 0
                      ]
                        ? (this.props.tournament.lang || [])[
                            this.props.trEmailTexts
                              ? (this.props.tournament.lang || []).indexOf(
                                  this.props.trEmailTexts
                                )
                              : 0
                          ]
                        : languages.getLanguage()
                    ]
                  : this.props.emailTexts[
                      "emailStart" +
                        (this.props.trEmailTexts ? this.props.trEmailTexts : "")
                    ].replace(/<br \/>/g, "\n")
              }
              style={{ marginBottom: 20 }}
              onChange={this.props.handleChange}
            />

            <Typography
              style={{
                background: "rgb(236, 239, 241)",
                padding: 10,
                borderRadius: 5,
                marginTop: 10,
                marginBottom: 20,
              }}
            >
              <InfoIcon style={{ height: 15, width: 15 }} />
              {" " + languages.signupPage.confirmationEmailInfo}
            </Typography>

            <TextField
              fullWidth
              id="textarea"
              label={languages.signupPage.confirmationEmailEnd}
              name="emailEnd"
              multiline
              value={
                this.props.emailTexts[
                  "emailEnd" +
                    (this.props.trEmailTexts ? this.props.trEmailTexts : "")
                ] === undefined
                  ? SignupEmailTexts.confirmationEmailEndText[
                      (this.props.tournament.lang || [])[
                        this.props.trEmailTexts
                          ? (this.props.tournament.lang || []).indexOf(
                              this.props.trEmailTexts
                            )
                          : 0
                      ]
                        ? (this.props.tournament.lang || [])[
                            this.props.trEmailTexts
                              ? (this.props.tournament.lang || []).indexOf(
                                  this.props.trEmailTexts
                                )
                              : 0
                          ]
                        : languages.getLanguage()
                    ]
                  : this.props.emailTexts[
                      "emailEnd" +
                        (this.props.trEmailTexts ? this.props.trEmailTexts : "")
                    ].replace(/<br \/>/g, "\n")
              }
              onChange={this.props.handleChange}
            />
          </DialogContent>
          {this.props.errorMessage && (
            <DialogActions>
              <div>
                <Typography style={{ color: "red" }}>
                  {this.props.errorMessage}
                </Typography>
              </div>
            </DialogActions>
          )}
          <DialogActions>
            <Button onClick={this.props.toggleDialog} color="primary">
              {languages.general.cancel}
            </Button>
            <Button
              onClick={this.props.handleSubmit}
              variant="contained"
              color="primary"
              type="submit"
            >
              {languages.general.save}
            </Button>
          </DialogActions>
        </form>
      </Dialog>
    );
  }
}
